import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import { Grid2 } from "@mui/material";

import { FixedLoadingIndicator } from "components/utility/FixedLoadingIndicator";

import { i18n } from "services/i18nService";
import {
  loginWithToken,
  getSystemUserCompanyData,
} from "services/sosInventoryService/sosApi";
import {
  setBearerToken,
  getCompanyData,
  setLastLoginCookie,
} from "services/utility/authentication";

import { openAlert } from "globalState/alertSlice";
import {
  setNeedsCompanyChooser,
  setIsLoggedIn,
} from "globalState/authenticationSlice";
import {
  setCompany,
  setCompanyList,
  setUser,
} from "globalState/userCompanySettingsSlice";

export function TokenAuth() {
  const { search } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    async function login(signupToken) {
      setIsLoading(true);
      const { success, data, message } = await loginWithToken(signupToken);
      if (success) {
        setBearerToken(data.access_token);
        const response = await getSystemUserCompanyData();
        if (!response) {
          setIsLoading(false);
          dispatch(
            openAlert({ type: "error", message: i18n("global.SomethingWentWrong") })
          );
          return;
        }
        const { company, companies, needsCompanyChooser } =
          getCompanyData(response);
        dispatch(setUser({ name: response.name, email: "" }));
        dispatch(setNeedsCompanyChooser(needsCompanyChooser));
        dispatch(setCompanyList(companies));
        dispatch(setCompany(company));
        setLastLoginCookie();
        dispatch(setIsLoggedIn("yes"));
        setIsLoading(false);
        navigate("/", { replace: true });
      } else {
        setIsLoading(false);
        dispatch(
          openAlert({
            type: "error",
            message: message || i18n("global.SomethingWentWrong"),
          })
        );
      }
    }

    const queryParams = new URLSearchParams(search);
    const signupToken = queryParams.get("signupToken");
    if (signupToken) {
      login(signupToken);
    } else {
      navigate("/login");
    }
  }, [navigate, search, dispatch]);

  return (
    <Grid2
      container
      spacing={0}
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: "100vh", width: "100%" }}
    >
      {isLoading ? (
        <FixedLoadingIndicator text={`${i18n("global.Loading")}...`} />
      ) : (
        <div>{i18n("login.LoggingIntoSOS")}</div>
      )}
    </Grid2>
  );
}
